'use client';

import type { FC, JSX } from 'react';
import React from 'react';
import type { PartialPageProps } from '@/types/cms/magnolia';
import dynamic from 'next/dynamic';
const Search = dynamic(() => import('./Search'), { ssr: false });

const SearchWrapper: FC<{ isInitialSearch?: boolean; pageProps?: PartialPageProps }> = (
  props
): JSX.Element => {
  return <Search {...props} />;
};

export default SearchWrapper;
